/**
 * Retailer has seen the confirmation modal for the non bm initial limit
 */ export var HAS_SEEN_NON_BM_INITIAL_LIMIT_CONFIRMATION_MODAL = 'HAS_SEEN_NON_BM_INITIAL_LIMIT_CONFIRMATION_MODAL';
